// @ts-nocheck
/* eslint-disable */
import { node } from "~/util/dom";
import { watch, watchCurrentUser } from "~/state/util";
import { sklikPhotoLike } from "~/util/sklik";
import { CONFIG } from "~/config";
import { setLike } from "~/util/providers/like";
import { _ } from "~/i18n";
import Map from "~/photo/components/map/map";
import MyMapsShare from "~/es6/mymaps.share";
import Description from "~/photo/detail/description";
import PhotoContextMenu from "~/photo/components/contextmenu";
import { backButton } from "~/photo/detail/components/back-button";
import { pagination } from "~/photo/detail/components/pagination";
import * as WheelZoom from "~/photo/detail/wheel-zoom";
import { zoomControl } from "~/photo/detail/components/zoom";
import { setGlobals, store, Provider, Canonical } from "~/photo/globals";
import { unsetDetail } from "~/state/detail/state";
import { addActiveContent, removeActiveContent } from "~/state/ribbon/state";

/* Detail fotky */
const DEFAULT_PROPS = {
	id: 0,
	source: "",
	list: [],
	detail: null,
	layers: [SMap.DEF_BASE],
	activeLayer: 0,
	//callback na zavreni s typem a pripadne source a id fotky a coords, pri kliku na malou mapku
	onClose: () => {},
};

export function initModule(global) {
	setGlobals(global);
}

export default class PhotoDetail {
	constructor(props) {
		this._props = Object.assign({}, DEFAULT_PROPS, props);
		this._node = node("div", { className: "photo-detail" });
		this._container = node("div");
		this._controls = node("div", { className: "controls" });
		this._image = node("div", { className: "image" });
		this._description = new Description();
		this._map = new Map("photo-map");
		this._photoContextMenu = new PhotoContextMenu(store);
		this._index = 0;
		this._back = null;
		this._thumb = null;
		this._zoom = null;
		this._detailData = null;
		this._setRAF = null;
		this._wzoom = null;
		this._animateCZ = false;
		this._gesture = null;
		this._prevGestureStatus = null;
		this._storeUnsubscribe = null;
	}

	destroy() {
		this._node.remove();
		this._props = null;
		this._detailData = null;
		this._index = 0;

		if (this._gesture) {
			this._gesture.destroy();
			this._gesture = null;
			this._prevGestureStatus = null;
		}

		this._photoContextMenu.destroy();
		this._map.destroy();
		this._description.destroy();

		if (this._wzoom) {
			this._wzoom.destroy();
		}
	}

	get node() {
		return this._node;
	}

	get detailData() {
		return this._detailData;
	}

	open(props = {}) {
		Mapy.getComponent("loader").start();

		this._props =  Object.assign({}, DEFAULT_PROPS, this._props, props);

		for (let i = 0; i < this._props.list.length; i++) {
			const item = this._props.list[i];
			if (item.id == this._props.id && item.source == this._props.source) {
				this._index = i;
				this._detailData = JSON.parse(JSON.stringify(item));
				break;
			}
		}

		const w = watch(store.getState, "user", watchCurrentUser);
		this._storeUnsubscribe = store.subscribe(w(() => {
			if (!Mapy.getComponent("gallery").isActive() && this._detailData?.approved === false) {
				this._props.onClose && this._props.onClose("close");
			}
		}));

		document.body.classList.add("gallery-detail");
		store.dispatch(addActiveContent("photo-detail"));

		this._load().then(open => {
			if (open) {
				this._build();
				document.body.appendChild(this._node);

				this.activateKeyboard();
				window.addEventListener("resize", this, false);
				document.addEventListener("fullscreenchange", this, false);

				this._photoContextMenu.node.addEventListener("photo-delete", this, false);
				this._node.addEventListener("click", this, false);

				this._setSEO();

				document.body.classList.add("no-refresh");

				Mapy.getComponent("loader").end();
			}
			else {
				Mapy.getComponent("photoDetail").deactivate();
			}
		}, () => {});
	}

	close() {
		this._node.remove();

		if (this._gesture) {
			this._gesture.destroy();
			this._gesture = null;
			this._prevGestureStatus = null;
		}

		if (this._setRAF) {
			cancelAnimationFrame(this._setRAF);
			this._setRAF = null;
		}

		if (this._photoContextMenu.open) {
			this._photoContextMenu.close();
		}

		this._storeUnsubscribe && this._storeUnsubscribe();
		store.dispatch(removeActiveContent("photo-detail"));

		document.body.classList.remove("gallery-detail");

		if (this._detailData) {
			this._detailData = null;

			document.body.classList.remove("no-refresh");

			this._photoContextMenu.node.removeEventListener("photo-delete", this, false);
			this._node.removeEventListener("click", this, false);

			document.removeEventListener("fullscreenchange", this, false);
			this.deactivateKeyboard();
			window.removeEventListener("resize", this, false);
		}
	}

	reopen(full) {
		if (this._index >= 0 && this._index <= this._props.list.length) {
			let fromHistory = Mapy.getComponent("history").isFromHistory();

			if (!full) {
				this._detailData = this._props.list[this._index];
			}
			else {
				this._detailData = null;
			}

			this._props =  Object.assign({}, DEFAULT_PROPS, this._props, full ? {} : {
				id: this._detailData.id,
				source: this._detailData.source,
			});

			this._load().then(open => {
				if (open) {
					this._animateCZ = true;
					this._build();

					this._setSEO();

					if (!fromHistory) {
						Mapy.getComponent("history").save();
					}
				}
			}, () => {});
		}
	}

	activateKeyboard() {
		window.addEventListener("keydown", this, false);
	}

	deactivateKeyboard() {
		window.removeEventListener("keydown", this, false);
	}

	handleEvent(event) {
		if (event.type === "click") {
			if (event.target === this._node || event.target === this._back || this._back.contains(event.target)) {
				event.stopPropagation();

				if (!this._image.classList.contains("grabbing")) {

					if (document.fullscreenElement) {
						document.exitFullscreen();
					}

					this._props.onClose && this._props.onClose("close");
				}
			}
			else if (event.target == this._map.node || this._map.node.contains(event.target)) {
				this._log({
					text: "mapPreview"
				});
				this._props.onClose && this._props.onClose("close-map-click", {
					source: this._detailData.source,
					id: this._detailData.id,
					mark: this._detailData.mark,
				});
			}
			else if (event.target.classList.contains("like-button") || event.target.closest("button.like-button")) {
				let promise = Promise.resolve();
				const { user } = store.getState().user;

				if (user.state !== "green") {
					promise = Mapy.getComponent("login").open({
						analyticsData: {
							loginOrigin: "photoLike",
							section: "reviews",
						},
						motivation: "like",
					});
				}

				promise.then(() => {
					let elm = event.target.classList.contains("like-button") ? event.target : event.target.closest("button.like-button");
					let like = !(elm.classList.contains("like") || elm.classList.contains("liked"));

					sklikPhotoLike();
					setLike(this._detailData.likes.id, like).then(res => {
						if (res.data) {
							let i = elm.querySelector("i");

							elm.classList.remove("liked");

							if (i) {
								i.innerText = res.data.count;
							}

							elm.classList[res.data.voted ? "add" : "remove"]("like");

							Provider.clear(this._detailData.source, this._detailData.id);

							let logData = {
								origin: "photos",
								type: res.data.voted ? "like" : "dislike",
								id: this._detailData.source === "index" ? this._detailData.urls[0].url : this._detailData.id,
								source: this._detailData.source === "index" ? "booking" : this._detailData.source,
							}

							this._log({
								text: "heart-button",
								...logData,
							});

							if (Mapy.getComponent("gallery").isActive()) {
								let gNode = Mapy.getComponent("gallery").node;

								if (gNode) {
									const e = new CustomEvent("like-change", {
										detail: {
											source: this._detailData.source,
											id: this._detailData.id,
											likes: res.data,
										}
									});

									gNode.dispatchEvent(e);
								}
							}
						}
					}, () => {});
				}, () => {});

				event.stopPropagation();
			}
			else if (event.target.classList.contains("share") || event.target.closest("button.share")) {
				let shareData = {
					title: `${_("gallery.share.photo")}${this._detailData.name && this._detailData.name != "" ? ` - ${this._detailData.name}` : ``}`,
					type: "photo",
					myGallery: this._props.my,
					noFrame: true,
				};
				let sharePopup = new MyMapsShare(shareData, cbData => {
					sharePopup.destroy();
					sharePopup = null;
					this.activateKeyboard();
				});
				sharePopup.open();
				this.deactivateKeyboard();

				this._log({
					text: _("action.share.title")
				});
			}
			else if (event.target.classList.contains("hide-full-text")) {
				this._container.classList.add("open");
			}
			else if (event.target.classList.contains("show-full-text")) {
				this._container.classList.remove("open");
			}
			else if (event.target.classList.contains("icon-etc-vertical") || event.target.closest("svg.icon-etc-vertical")) {
				let elm = event.target.classList.contains("icon-etc-vertical") ? event.target : event.target.closest("svg.icon-etc-vertical");
				let bb = elm.getBoundingClientRect();
				const { user } = store.getState().user;

				this._photoContextMenu.data = {
					id: this._detailData.id,
					source : this._detailData.source,
					userPublicId: (this._detailData.author?.userPublicId && !this._detailData.review)
						|| (this._detailData.review && this._detailData.author?.userPublicId === user.userPublicId)
						? this._detailData.author.userPublicId
						: 0,
					detail: true,
					title: this._detailData.name,
					coords: this._detailData.mark,
					url: this._detailData.urls[0].url,
					url300: Mapy.CDN.setSize(this._detailData.urls[1].url, Mapy.CDN.SIZE_400_400, false),
					my: this._props.my,
					review: !!(this._detailData.review || this._detailData.reviewId),
					exif: this._detailData.exif,
					approved: this._detailData.approved,
					poi: this._props.poi,
				};

				this._photoContextMenu.node.style.top = bb.top + "px";
				this._photoContextMenu.node.style.left = bb.left + "px";

				this._node.appendChild(this._photoContextMenu.node);

				event.stopPropagation();
			}
			else if (event.target.classList.contains("prev") || event.target.closest("button.prev")) {
				this._prevImage();
			}
			else if (event.target.classList.contains("next") || event.target.closest("button.next")) {
				this._nextImage();
			}
			else if (event.target.classList.contains("plus") || event.target.closest("button.plus")) {
				if (this._wzoom) {
					this._wzoom.zoomUp();

					this._log({
						text: "plus"
					});
				}
			}
			else if (event.target.classList.contains("minus") || event.target.closest("button.minus")) {
				if (this._wzoom) {
					this._wzoom.zoomDown();

					this._log({
						text: "minus"
					});
				}
			}
			else if (event.target.classList.contains("photo-fullscreen") || event.target.closest("button.photo-fullscreen")) {
				this._toggleFullscreen();
			}
			else if (event.target.classList.contains("author") || event.target.closest("a.author")) {
				if (!Mapy.Util.linkToNewWindow(event)) {
					event.preventDefault();
					event.stopPropagation();

					const userPublicId = this._detailData.author?.userPublicId || "";

					if (this._detailData.review || this._props.source === "revi") {
						this._props.onClose && this._props.onClose("close");

						if (Mapy.getComponent("gallery").isActive()) {
							Mapy.getComponent("gallery").deactivate();
						}

						Mapy.getComponent("userProfile").setState({
							up: userPublicId,
							upc: "reviews",
						}).then(() => {
							store.dispatch(unsetDetail());
							Mapy.getComponent("history").save();
						}, () => {});
					} else {
						const authorTxt = (event.target.classList.contains("author") || event.target.closest("a.author")).innerText || "";

						this._log({
							text: authorTxt.replace(/[\t\n]/g, ""),
						});

						this._props.onClose && this._props.onClose("close");

						Mapy.Util.openPhotogallery(userPublicId);
						Mapy.getComponent("history").save();
					}
				}
			}
			else {
				if (!event.target.closest(".controls div.bottom") && !event.target.closest(".controls div.top") && this._node.offsetWidth < 480) {
					this._controls.classList.toggle("hide");
				}
			}
		}
		else if (event.type == "keydown") {
			if (this._props.list.length) {
				if (event.keyCode == 37 || event.keyCode == 8) {
					this._prevImage();

					event.stopPropagation();
				}
				else if (event.keyCode == 39 || event.keyCode == 32) {
					this._nextImage();

					event.stopPropagation();
				}
			}

			if (this._wzoom) {
				if (event.keyCode == 107) {
					this._wzoom.zoomUp();

					this._log({
						text: "plus"
					});
				}
				else if (event.keyCode == 109) {
					this._wzoom.zoomDown();

					this._log({
						text: "minus"
					});
				}
			}

			if (event.keyCode == 27) {
				if (!this._photoContextMenu.close()) {
					event.stopPropagation();

					this._props.onClose && this._props.onClose("close");
				}
			}

			if (event.keyCode == 70) {
				this._toggleFullscreen();
			}
		}
		else if (event.type == "fullscreenchange") {
			this._container.classList[document.fullscreenElement ? "add" : "remove"]("fs");

			let button = this._container.querySelector("button.photo-fullscreen");
			if (button) {
				button.title = document.fullscreenElement ? _("photo.fullscreen.off") : _("photo.fullscreen");
			}

			if (this._wzoom) {
				requestAnimationFrame(() => {
					// setTimeout, pac kdyz jhsou otevrene nastroje, tak pri prechodu do fullscreenu jim to trva nez se otevrou
					// a tim by se spatne napocitali velikosti pro zoomovani
					window.setTimeout(() => {
						this._wzoom.prepare();
						this._checkSize();
					},100);
				});
			}
		}
		else if (event.type == "resize") {
			if (this._wzoom) {
				this._wzoom.prepare();
			}
		}
		else if (event.type == "photo-delete") {
			this._props.onClose && this._props.onClose("photo-delete", {
				source: this._detailData.source,
				id: this._detailData.id,
			});
		}
	}

	_load() {
		let promise = Promise.resolve();

		// pokud je source "index" nechceme tahat zadne dalsi data, protoze neexistujou (booking fotky)
		if (["index"].indexOf(this._props.source) === -1/* && this._props.galleryType !== "review"*/) {
			if (!this._detailData || this._props.galleryType === "review") {
				// dotaz na providera o data a az pak build
				promise = Provider.detail({
					source: this._props.source,
					id: this._props.id,
					full: true,
				}).then(data => {
					if (!data.error) {
						if (this._props.galleryType !== "review") {
							this._props.list = JSON.parse(JSON.stringify(data.gallery));
						}
						this._detailData = JSON.parse(JSON.stringify(data.gallery[0]));

						return true;
					}
					else {
						return false;
					}
				}, () => {});
			} else {
				promise = Provider.detail({
					source: this._props.source,
					id: this._props.id,
				}).then(data => {
					if (!data.error) {
						Object.assign(this._detailData, JSON.parse(JSON.stringify(data.gallery[0])));

						return true;
					}
					else {
						return false;
					}

				}, () => {});
			}
		} else {
			promise = Promise.resolve(true);
		}

		return promise;
	}

	_build() {
		//this._node.innerHTML = "";
		this._container.innerHTML = "";
		this._controls.innerHTML = "";
		this._image.innerHTML = "";

		this._image.classList.remove("grab");
		this._container.classList.remove("not-approved");

		if (this._detailData.approved === false) {
			this._container.classList.add("not-approved");
		}

		const top = node("div", { className: "top" });
		const bottom = node("div", { className: "bottom" });
		const top1 = node("div");

		this._back = backButton({
			contentText: this._props.backTitle || `${_("back")} ${Mapy.getComponent("gallery").isActive() ? `${_("photo.detail.back")}` : `${_("photo.detail.backMap")}`}`,
		});
		top1.appendChild(this._back);

		const top2 = node("div");
		if (this._props.count && this._props.list.length > 1) {
			top2.appendChild(pagination(this._index, this._props.count));
		}

		const top3 = node("div");

		top.appendChild(top1);
		top.appendChild(top2);
		top.appendChild(top3);

		const bottom1 = node("div");
		bottom1.appendChild(this._map.node);

		const bottom2 = node("div");
		this._description.data = JSON.parse(JSON.stringify({
			detail: this._detailData,
			my: this._props.my,
		}));
		bottom2.appendChild(this._description.node);

		const bottom3 = node("div");
		this._thumb = WheelZoom.createThumb(this._detailData.urls[1].url);
		bottom3.appendChild(this._thumb);

		bottom.appendChild(bottom1);
		bottom.appendChild(bottom2);
		bottom.appendChild(bottom3);

		this._zoom = zoomControl();

		this._controls.appendChild(top);
		this._controls.appendChild(this._zoom);
		this._controls.appendChild(bottom);

		this._image.appendChild(this._buildImage());
		this._loadNextAnrPrevImage();

		// nazev a tak pro tisk
		const printInfo = node("section", { className: "print-info" });

		if (this._detailData.name) {
			printInfo.appendChild(node("h1", { innerText: this._detailData.name }));
		}
		if (this._detailData.author && this._detailData.author.name) {
			printInfo.appendChild(node("p", { innerText: `${_("photo.author")}: ${this._detailData.author.name}`, className: "author" }));
		}
		if (this._detailData.date) {
			printInfo.appendChild(node("p", { innerHTML: new Date(this._detailData.date).toLocaleDateString() }));
		}
		if (this._detailData.description) {
			printInfo.appendChild(node("p", { innerHTML: Mapy.Util.escapeHTML(this._detailData.description) }));
		}

		this._container.appendChild(this._image);
		this._container.appendChild(this._controls);
		this._container.appendChild(printInfo);


		if (document.fullscreenElement !== this._container) {
			this._node.appendChild(this._container);
		}

		this._setRAF = requestAnimationFrame(() => {
			this._setRAF = null;

			this._setMap();

			if (this._gesture) {
				this._gesture.destroy();
				this._gesture = null;
			}

			let content = this._image.querySelector(".photo-content");
			if (content) {
				this._gesture = new SMap.Gesture(content);

				this._gesture.add(new SMap.GestureSwipe((eventName, data) => {
					if (!this._wzoom || (this._wzoom && this._wzoom.content.currentScale === this._wzoom.content.minScale)) {
						if (eventName === "swipe-left") {
							this._nextImage();
						}
						else if (eventName === "swipe-right") {
							this._prevImage();
						}
					}
				}, {
					maxDuration: 250,
				}));
			}

			if (CONFIG?.printMode !== 3 && (this._container.offsetWidth < this._detailData.width || this._container.offsetHeight < this._detailData.height)) {
				this._setWZ();
			}
			else {
				this._thumb.innerHTML = "";
				this._zoom.innerHTML = "";
			}

			if (CONFIG?.printMode === 3) {
				const logo = node("img", { src: `/img/logo/com/logo-print.svg` });
				logo.style.position = "absolute";
				logo.style.bottom = "10px";
				logo.style.right = "10px";
				this._node.append(logo);
			}

			this._description.clamp();
			this._map.sync();
		});
	}

	_setMap() {
		if (this._detailData.mark) {
			const coords = [SMap.Coords.fromWGS84(this._detailData.mark.lon, this._detailData.mark.lat)];

			if (this._props.detail && this._props.detail.coords) {
				coords.push(SMap.Coords.fromWGS84(this._props.detail.coords[0], this._props.detail.coords[1]));
			}

			this._map.sync();
			this._map.layer = this._props.activeLayer || 0;
			this._map.clearMarkers();
			this._map.addMarkers([JSON.parse(JSON.stringify(this._detailData))]);
			const cz = this._map.computeCenterZoom(coords);

			if (cz[1] > 0 && cz[1] < 30) {
				this._map.centerZoom = {
					coords: [cz[0].x, cz[0].y],
					zoom: cz[1] > 17 ? 17 : cz[1],
					animate: this._animateCZ,
				};

				this._animateCZ = false;
			}
		}
	}

	_setWZ() {
		this._image.classList.add("grab");

		if (this._gesture) {
			this._gesture.add(new SMap.GesturePinch((eventName, data) => {
				let scale = Math.round(Math.log(data.scale)/0.2);

				if (this._prevGestureStatus && scale > this._prevGestureStatus.scale) {
					this._wzoom.zoomUp();

				}
				else if (this._prevGestureStatus && scale < this._prevGestureStatus.scale) {
					this._wzoom.zoomDown();
				}

				this._prevGestureStatus = eventName === "pinch-end" ? null : { scale };
			}));
		}

		if (this._wzoom) {
			this._wzoom.destroy();
		}

		this._wzoom = WheelZoom.create(JSON.parse(JSON.stringify(this._detailData)), this._image, ".photo-content", this._thumb);
	}

	_buildImage() {
		CONFIG.isScreenshoter && Mapy.getComponent("loader").start();
		const frame = node("div", { className: "photo-frame" });
		const content = node("div", { className: "photo-content" });
		const img = node("img", { src: this._detailData.urls[0].url, alt: "" });
		const placeholderImg = node("img", { src: Mapy.CDN.setSize(this._detailData.urls[1].url, Mapy.CDN.SIZE_40_40), alt: "", className: "placeholder", crossOrigin: "anonymous" });

		placeholderImg.style.width = `${this._detailData.width}px`;
		placeholderImg.style.height = `${this._detailData.height}px`;

		img.addEventListener("load", () => {
			img.style.opacity = 1;
			placeholderImg.style.opacity = 0;
			CONFIG.isScreenshoter && window.setTimeout(() => {
				Mapy.getComponent("loader").end();
			}, 200);
		});

		img.addEventListener("error", () => {
			img.style.opacity = 1;
			placeholderImg.style.opacity = 0;
			Mapy.getComponent("loader").end();
		});

		content.appendChild(placeholderImg);
		content.appendChild(img);
		frame.appendChild(content);

		return frame;
	}

	_checkSize() {
		let photoContent = this._image.querySelector("div.photo-frame");

		if (this._detailData.width <= photoContent.offsetWidth && this._detailData.height <= photoContent.offsetHeight) {
			this._container.classList.add("nowz");
			this._image.classList.remove("grab");
		}
		else {
			this._container.classList.remove("nowz");
			this._image.classList.add("grab");
		}
	}

	_prevImage() {
		if (this._index > 0) {
			this._log({
				text: "previous",
			});

			this._index--;
			this.reopen();
		}
	}

	_nextImage() {
		if (this._index < this._props.count-1) {
			this._log({
				text: "next",
			});

			this._index++;

			// pokud nemame stranky donactene, tak se je pokusime nejdrive nacist, abychom vedeli, jaka je dalsi fotka a az pak otevrem
			if (Mapy.getComponent("gallery").isActive() && this._props.list.length < this._props.count && this._index > this._props.list.length-3) {
				Mapy.getComponent("gallery").loadNextPage().then(data => {
					this._props.list = data;

					this.reopen();
				}, () => {});
			}
			else {
				this.reopen();
			}
		}
	}

	_loadNextAnrPrevImage() {
		if (this._props.list.length) {
			if (this._index > 0 && this._props.list[this._index - 1]) {
				let prev = this._props.list[this._index - 1];
				let prevUrl = prev.urls && prev.urls.length ? prev.urls[0].url : "";

				if (prevUrl && prevUrl != "") {
					node("img", { src: prevUrl });
				}
			}

			if (this._index < this._props.list.length && this._props.list[this._index + 1]) {
				let next = this._props.list[this._index + 1];
				let nextUrl = next.urls && next.urls.length ? next.urls[0].url : "";

				if (nextUrl && nextUrl != "") {
					node("img", { src: nextUrl });
				}
			}
		}
	}
	_toggleFullscreen() {
		if (document.fullscreenElement) {
			document.exitFullscreen();

			this._log({
				text: "fullscreenClose"
			});
		}
		else {
			this._container.requestFullscreen();

			this._log({
				text: "fullscreenOpen"
			});
		}

		this._thumb.classList.remove("show");
	}

	_getLogData(data) {
		let galleryLogData = Mapy.getComponent("gallery").isActive() ? Mapy.getComponent("gallery").logData : Mapy.getComponent("photoDetail").options?.galleryType ? { galleryType: Mapy.getComponent("photoDetail").options.galleryType } : {};

		return {
			...galleryLogData,
			...{
				galleryType: galleryLogData.galleryType ? galleryLogData.galleryType : "photomap",
				section: "gallery",
				place: "detail",
			},
			...data,
		};
	}

	_log(data, action = "click") {
		let galleryLogData = Mapy.getComponent("gallery").isActive() ? Mapy.getComponent("gallery").logData : Mapy.getComponent("photoDetail").options?.galleryType ? { galleryType: Mapy.getComponent("photoDetail").options.galleryType } : {};

		Mapy.getComponent("logger").log(action, this._getLogData(data));
	}

	_setSEO() {
		const date = new Date(this._detailData.date);

		Mapy.SEO.set(
			`${_("gallery.share.photo")}${this._detailData.name && this._detailData.name != "" ? ` - ${this._detailData.name}` : ``}${this._detailData.date ? ` - ${Mapy.Util.dateToLocaleFormatLocal(date)}` : ``}`,
			false,
			false,
			Mapy.getComponent("photoDetail")
		);

		Canonical.set("/", {
			sourcep: this._detailData.source,
			idp: this._detailData.id,
		});
	}
}
